/**
 * Shared values for the `flow` log field, which groups logs that belong to the same end-to-end
 * user flow so they can be searched together (e.g. `flow:workspace-loading` in the log store, or by
 * filtering the DevTools console on the value). Use a single constant per flow so the token stays
 * identical across the files that emit it.
 */
export const LogFlow = {
    /** Everything on the path that renders the workspace loader: agent SDK creation + wrapping. */
    WorkspaceLoading: "workspace-loading",
} as const;
